const key = 'exam'

/**
 * The Exam an Admin is working on, chosen once and carried in the address: `/tmua/...`.
 *
 * The address is the truth, so a bookmark, a shared link and the back button all say which
 * Exam a screen is about. What is kept here is only the last choice, so that opening the
 * site at `/` goes straight back to it rather than asking again.
 */
export function rememberedExam(): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function rememberExam(code: string): void {
  try {
    localStorage.setItem(key, code)
  } catch {
    // Nowhere to remember into, which only costs the shortcut from `/`.
  }
}

/** For an Exam the catalogue no longer has, so `/` stops sending people to a screen that says so. */
export function forgetExam(): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // Nothing was remembered either.
  }
}

/** The address form of an Exam Code: `/tmua`, because an address shouts less than a code. */
export function slugOf(code: string): string {
  return code.toLowerCase()
}

/** The Exam Code an address segment names, in the form the API and the catalogue use (app:R77). */
export function codeOf(slug: string): string {
  return slug.toUpperCase()
}
